// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eb85ba16","455":"e57cf5ad"}[chunkId] + ".chunk.js";
};